/**
 * NIGHTBOUND - the wordmark.
 *
 * A single inline SVG sigil plus the name. Used on the title screen, the auth
 * screen and (small) in the nav. Never loads the reference sheet.
 */

import { cx } from './ui'

export function Logo({ size = 'md', tagline }: { size?: 'sm' | 'md' | 'lg'; tagline?: string }) {
  const text = size === 'lg' ? 'text-3xl sm:text-4xl' : size === 'md' ? 'text-xl' : 'text-sm'
  const sigil = size === 'lg' ? 'h-16 w-16' : size === 'md' ? 'h-9 w-9' : 'h-6 w-6'
  return (
    <div className="flex items-center gap-3">
      <Sigil className={cx(sigil, 'shrink-0 text-ember-500')} />
      <div className="leading-none">
        <div className={cx('nb-title text-bone-200', text)}>Nightbound</div>
        {tagline ? (
          <div className="mt-1.5 nb-label text-[9px] tracking-[0.3em] text-ash-400">{tagline}</div>
        ) : null}
      </div>
    </div>
  )
}

export function Sigil({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
      className={className}
      fill="none"
    >
      <circle cx="24" cy="24" r="21" stroke="currentColor" strokeOpacity="0.35" strokeWidth="1" />
      <circle cx="24" cy="24" r="15" stroke="currentColor" strokeOpacity="0.2" strokeWidth="0.75" />
      {/* Crescent */}
      <path
        d="M30 12a13 13 0 1 0 6 22 15 15 0 0 1-6-22z"
        fill="currentColor"
        fillOpacity="0.16"
        stroke="currentColor"
        strokeWidth="1.2"
      />
      {/* Eye */}
      <path
        d="M17 26c3-4 8-5 12-2M29 24c-3 4-8 5-12 2"
        stroke="currentColor"
        strokeWidth="1.1"
        strokeLinecap="round"
      />
      <circle cx="23" cy="25" r="1.6" fill="currentColor" />
    </svg>
  )
}
